import { render, staticRenderFns } from "./AccessionDistribution.vue?vue&type=template&id=3b72e991&scoped=true&"
import script from "./AccessionDistribution.vue?vue&type=script&lang=js&"
export * from "./AccessionDistribution.vue?vue&type=script&lang=js&"
import style0 from "./AccessionDistribution.vue?vue&type=style&index=0&id=3b72e991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b72e991",
  null
  
)

export default component.exports